import { ParollConstants } from "constants/constants";
import { initialPayrollState } from "store/initialStates";
import { PayrollState } from "types/Payroll";
import { ReducersInterfaceAction } from "types/Reducers";

export const payrollReducer = (
  state = initialPayrollState,
  action: ReducersInterfaceAction,
): PayrollState => {
  switch (action.type) {
    case ParollConstants.PAYROLL_TABLE_GET_DATA_SUCCESS:
      return { ...state, loadingData: false, ...action.payload };
    case ParollConstants.PAYROLL_TABLE_GET_DATA_LOADING:
      return { ...state, loadingData: true };
    case ParollConstants.PAYROLL_TABLE_GET_DATA_ERROR:
      return { ...state, loadingData: false };
    case ParollConstants.PAYROLL_TABLE_CREATE_UPDATE_REPORT:
      return { ...state, loadingData: false, dataList: action.payload };
    case ParollConstants.PAYROLL_PAGE_SET_FILTERS:
      return { ...state, payrollFilters: action.payload };
    case ParollConstants.PAYROLL_TABLE_SET_SELECTED_USER_DATES:
      return { ...state, selctedUserDatesList: action.payload };
    case ParollConstants.PAYROLL_TABLE_PAYROLL_SEND_MESSAGES:
      return { ...state, selctedUserDatesList: [] };
    default:
      return state;
  }
};
